import { Button as UiButton, Skeleton as UiSkeleton, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

type StyledButtonProps = {
    selected?: boolean
}

export const Button = styled(UiButton, { shouldForwardProp: prop => prop !== "selected" })<StyledButtonProps>(({ disabled, selected, theme }) => ({
    backgroundColor: disabled ? theme.palette["common/gray_states"].main : undefined,
    outline: selected
        ? `2px solid ${theme.palette["primary"].main}`
        : `1px solid ${theme.palette.divider}`,
    outlineOffset: selected ? "-2px" : "-1px",
    boxSizing: "border-box",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(2, 3),
    minWidth: "fit-content",
}))

type StyledTextProps = {
    color: "text/disabled" | "common/black_states"
}

export const Text = styled(Typography, { shouldForwardProp: prop => prop !== "color" })<StyledTextProps>(({ color, theme }) => ({
    color: theme.palette[color].main,
}))

export const OptionsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    boxSizing: "border-box",
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    maxWidth: "100%",
    overflowX: "auto",
    gap: theme.spacing(1),
}))

export const Wrapper = styled("div")({
})

export const Skeleton = styled(UiSkeleton)(({ theme }) => ({
    height: 82,
    marginTop: theme.spacing(2),
    transform: "scale(1)",
    width: "100%",
}))

export const ErrorWrapper = styled("div")(({ theme }) => ({
    height: 82,
    marginTop: theme.spacing(2),
    width: "100%",
}))

export const ErrorText = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))
